import { apiClient } from "../../lib/axios";
import type { MetricsFilters } from "./types";

export interface UsageDailyPoint {
  label: string; // YYYY-MM-DD
  opens: number;
  active_users: number;
}

export interface UsageStatsResponse {
  data: {
    total_opens: number;
    active_users: number;
    active_days: number;
    daily: UsageDailyPoint[];
  };
}

const buildQueryParams = (params?: MetricsFilters) => {
  const q: Record<string, unknown> = {};
  if (params?.start_date) q.start_date = params.start_date;
  if (params?.end_date) q.end_date = params.end_date;
  if (params?.region?.length) q.region = params.region;
  if (params?.department?.length) q.department = params.department;
  if (params?.age_range?.length) q.age_range = params.age_range;
  if (params?.sex) q.sex = params.sex;
  if (params?.shift_pattern?.length) q.shift_pattern = params.shift_pattern;
  if (params?.user_ids?.length) q.user_ids = params.user_ids;
  if (params?.client_id) q.client_id = params.client_id;
  return q;
};

export const usageApi = {
  getStats: async (params?: MetricsFilters): Promise<UsageStatsResponse> => {
    const url = params?.client_id
      ? "/admin/client-usage/stats"
      : "/admin/usage/stats";
    const response = await apiClient.get(url, { params: buildQueryParams(params) });
    return response.data;
  },
};
